exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.logo--3nwD_wAK{max-height:3rem;max-width:6.5rem}@media only screen and (min-width:600px) and (max-width:1023px){.logo--3nwD_wAK{max-height:3rem;max-width:8rem}}@media (min-width:1024px){.logo--3nwD_wAK{max-height:4rem;max-width:9rem}}", ""]);

// exports
exports.locals = {
	"logo": "logo--3nwD_wAK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/sign_up/shared/logo/styles.scss
// module id = 1045
// module chunks = 0